import { get, includes, map, set, values } from 'lodash'

import { INGREDIENT_KEYWORD_SUBTYPES } from '../../common/constants'

const createSubtypeNodes = node => {
  if (!includes([2, 4], node.level)) {
    return null
  }
  const subtypes =
    node.level === 2
      ? values(INGREDIENT_KEYWORD_SUBTYPES)
      : get(INGREDIENT_KEYWORD_SUBTYPES, `${node.subtype}.childrenKeyTypes`)

  return map(subtypes, ({ id, term }, index) => {
    const subtypeKey = `${node.key}-${index}`
    const subtypePath = `${node.path}.children[${index}]`
    const subtypeKeyPath = [...node.keyPath, `${node.key}-${index}`]

    return {
      id: `${node.id}-${id}`,
      term,
      subtype: id,
      type: node.type,
      key: subtypeKey,
      path: subtypePath,
      keyPath: subtypeKeyPath,
      parentPath: node.path,
      level: node.level + 1,
      parentId: node.id,
      children: [],
      isSubtype: true,
      allowedOperations: node.allowedOperations,
      isModified: true,
    }
  })
}

const addKeywordNode = (node, field, keywordsState) => {
  const { parentPath } = node

  const subtypeNodes = createSubtypeNodes(node)

  const pathToAddNodeTo = `data.${field}${parentPath}.children`

  const arrayToAddNodeTo = get(keywordsState, pathToAddNodeTo, [])

  arrayToAddNodeTo.push({
    ...node,
    isModified: true,
    children: subtypeNodes,
  })

  return set(keywordsState, pathToAddNodeTo, arrayToAddNodeTo)
}

export default addKeywordNode
